
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import userService from './userService'

const initialState = {
    user: [],
    users: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
    listLoading: false,
    listError: false,
    listMessage: '',
    updateLoading: false,
    updateError: false,
    updateMessage: '',
    createLoading: false,
    createError: false,
    createMessage: ''
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        reset: (state) => initialState,
        setUserActiveOptimistic: (state, action) => {
            const { id, isActive, updatedAt } = action.payload || {};
            const target = state.users.find((user) => (user.id || user.userId) === id);
            if (target) {
                target.isActive = isActive;
                if (updatedAt) target.updatedAt = updatedAt;
            }
        },
        revertUserActive: (state, action) => {
            const { id, prevIsActive } = action.payload || {};
            const target = state.users.find((user) => (user.id || user.userId) === id);
            if (target) {
                target.isActive = prevIsActive;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createUser.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.user = action.payload
            })
            .addCase(createUser.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })


            .addCase(updateUser.pending, (state) => {
                state.isLoading = true
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.users.unshift(action.payload)
            })
            .addCase(updateUser.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            .addCase(getUser.pending, (state) => {
                state.isLoading = true
                state.isSuccess = false
            })
            .addCase(getUser.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isError = false
                state.user = action.payload
            })
            .addCase(getUser.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })

            .addCase(listUsers.pending, (state) => {
                state.listLoading = true
                state.listError = false
                state.listMessage = ''
            })
            .addCase(listUsers.fulfilled, (state, action) => {
                state.listLoading = false
                state.listError = false
                state.users = action.payload
            })
            .addCase(listUsers.rejected, (state, action) => {
                state.listLoading = false
                state.listMessage = action.payload
                state.listError = true
            })
            .addCase(updateUserActive.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(updateUserActive.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const updated = action.payload
                const target = state.users.find((user) => (user.id || user.userId) === updated?.id)
                if (target) {
                    Object.assign(target, updated)
                }
            })
            .addCase(updateUserActive.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
                const { id, prevIsActive } = action.meta?.arg || {}
                if (id !== undefined && prevIsActive !== undefined) {
                    const target = state.users.find((user) => (user.id || user.userId) === id)
                    if (target) {
                        target.isActive = prevIsActive
                    }
                }
            })
            .addCase(updateUserById.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(updateUserById.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const updated = action.payload
                const target = state.users.find((user) => (user.id || user.userId) === updated?.id)
                if (target) {
                    Object.assign(target, updated)
                }
            })
            .addCase(updateUserById.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
            })
            .addCase(deleteUserById.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(deleteUserById.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const deletedId = action.payload?.id
                if (deletedId) {
                    state.users = state.users.filter((user) => (user.id || user.userId) !== deletedId)
                }
            })
            .addCase(deleteUserById.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
            })
            .addCase(assignUserDemo.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(assignUserDemo.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const updated = action.payload
                const target = state.users.find((user) => (user.id || user.userId) === updated?.id)
                if (target) {
                    Object.assign(target, updated)
                }
            })
            .addCase(assignUserDemo.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
            })
            .addCase(setUserStandard.pending, (state) => {
                state.updateLoading = true
                state.updateError = false
                state.updateMessage = ''
            })
            .addCase(setUserStandard.fulfilled, (state, action) => {
                state.updateLoading = false
                state.updateError = false
                const updated = action.payload
                const target = state.users.find((user) => (user.id || user.userId) === updated?.id)
                if (target) {
                    Object.assign(target, updated)
                }
            })
            .addCase(setUserStandard.rejected, (state, action) => {
                state.updateLoading = false
                state.updateError = true
                state.updateMessage = action.payload
            })
            .addCase(createUserByAdmin.pending, (state) => {
                state.createLoading = true
                state.createError = false
                state.createMessage = ''
            })
            .addCase(createUserByAdmin.fulfilled, (state) => {
                state.createLoading = false
                state.createError = false
            })
            .addCase(createUserByAdmin.rejected, (state, action) => {
                state.createLoading = false
                state.createError = true
                state.createMessage = action.payload
            })

    }
})

export const createUser = createAsyncThunk('user/createUser', async ({ uid, phoneNumber, email }, thunkAPI) => {
    try {
        return await userService.createUser(uid, phoneNumber, email);
    } catch (error) {
        const message = error.message;
        return thunkAPI.rejectWithValue(message);
    }
})

export const createUserWithEmail = createAsyncThunk('user/createUserWithEmail', async (user, thunkAPI) => {
    try {
        return await userService.createUser(user.uid, user.phoneNumber)
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const getUser = createAsyncThunk('user/getUser', async (_, thunkAPI) => {
    try {
        const userId = thunkAPI.getState().auth.user.uid;
        return await userService.getUser(userId)
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateUser = createAsyncThunk('user/updateUser', async (userData, thunkAPI) => {
    try {
        const userId = thunkAPI.getState().auth.user.uid;
        return await userService.updateUser(userData, userId);
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message);
    }
})

export const listUsers = createAsyncThunk('user/listUsers', async (_, thunkAPI) => {
    try {
        return await userService.listUsers()
    } catch (error) {
        const message = error?.message || 'Kullanıcılar yüklenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateUserActive = createAsyncThunk('user/updateUserActive', async ({ id, isActive }, thunkAPI) => {
    try {
        return await userService.updateUserActive(id, isActive)
    } catch (error) {
        const message = error?.message || 'Kullanıcı durumu güncellenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateUserById = createAsyncThunk('user/updateUserById', async ({ id, data }, thunkAPI) => {
    try {
        return await userService.updateUserById(id, data)
    } catch (error) {
        const message = error?.message || 'Kullanıcı güncellenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteUserById = createAsyncThunk('user/deleteUserById', async ({ id }, thunkAPI) => {
    try {
        return await userService.deleteUserById(id)
    } catch (error) {
        const message = error?.message || 'Kullanıcı silinemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const createUserByAdmin = createAsyncThunk('user/createUserByAdmin', async (payload, thunkAPI) => {
    try {
        return await userService.createUserByAdmin(payload)
    } catch (error) {
        const message = error?.message || 'Kullanıcı oluşturulamadı.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const updateUserBusinessId = createAsyncThunk('user/updateUserBusinessId', async ({ id, businessId }, thunkAPI) => {
    try {
        return await userService.updateUserBusinessId(id, businessId)
    } catch (error) {
        const message = error?.message || 'Kullanıcı firması güncellenemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const assignUserDemo = createAsyncThunk('user/assignUserDemo', async ({ id, demostartdate, demoenddate }, thunkAPI) => {
    try {
        return await userService.assignUserDemo(id, { demostartdate, demoenddate })
    } catch (error) {
        const message = error?.message || 'Demo tanımlaması yapılamadı.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const setUserStandard = createAsyncThunk('user/setUserStandard', async ({ id }, thunkAPI) => {
    try {
        return await userService.setUserStandard(id)
    } catch (error) {
        const message = error?.message || 'Kullanıcı standart pakete geçirilemedi.'
        return thunkAPI.rejectWithValue(message)
    }
})

export const { reset, setUserActiveOptimistic, revertUserActive } = userSlice.actions
export const selectUsers = (state) => state.user.users
export const selectUsersLoading = (state) => state.user.listLoading
export const selectUsersError = (state) => state.user.listError
export const selectUsersMessage = (state) => state.user.listMessage
export const selectUsersUpdateError = (state) => state.user.updateError
export const selectUsersUpdateMessage = (state) => state.user.updateMessage
export const selectUsersCreateLoading = (state) => state.user.createLoading
export const selectUsersCreateError = (state) => state.user.createError
export const selectUsersCreateMessage = (state) => state.user.createMessage
export default userSlice.reducer
